module.exports = "/static/assets/c813c12e83ecc80fa1ba8f60752db9a3.png";